import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InboxStatus = 'unread' | 'read' | 'archived';

export interface InboxItem {
  id: string;
  type: string;
  title: string;
  body: string;
  data?: Record<string, any>;
  status: InboxStatus;
  created_at: string;
}

export interface InboxState {
  items: InboxItem[];
  unreadCount: number;
}

const initialState: InboxState = {
  items: [],
  unreadCount: 0,
};

const inboxSlice = createSlice({
  name: 'inbox',
  initialState,
  reducers: {
    setInbox(state, action: PayloadAction<InboxItem[]>) {
      state.items = action.payload;
    },
    setUnreadCount(state, action: PayloadAction<number>) {
      state.unreadCount = action.payload;
    },
    // A live notification arrived over the websocket; prepend it (dedup by id).
    receiveNotification(state, action: PayloadAction<InboxItem>) {
      const incoming = action.payload;
      if (state.items.some((n) => n.id === incoming.id)) return;
      state.items.unshift(incoming);
      if (incoming.status === 'unread') {
        state.unreadCount += 1;
      }
    },
    markItemRead(state, action: PayloadAction<string>) {
      const item = state.items.find((n) => n.id === action.payload);
      if (item && item.status === 'unread') {
        item.status = 'read';
        state.unreadCount = Math.max(0, state.unreadCount - 1);
      }
    },
    markAllRead(state) {
      state.items.forEach((n) => {
        n.status = 'read';
      });
      state.unreadCount = 0;
    },
  },
});

export const {
  setInbox,
  setUnreadCount,
  receiveNotification,
  markItemRead,
  markAllRead,
} = inboxSlice.actions;

export default inboxSlice.reducer;
